export default __webpack_public_path__ + "static/media/icon-eye.764d29a2.svg";